#import "../../../graphql/fragments/meeting-fragment.graphql"

mutation ResetManagedMeetingChanges($input: ManagedMeetingResetChangesInput!) {
    managedMeetingResetChanges(input: $input) {
        meeting {
            ...MeetingFragment
        }
    }
}
